var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehanceLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66333 11.6517C12.2967 11.6517 12.2967 20 6.66333 20H2V11.6517M6.66333 11.6517H2M6.66333 11.6517C12.2967 11.6517 12.2967 4 6.66333 4H2V11.6517M13.1111 14.4615C13.1111 11.4031 15.1 8.92308 17.5556 8.92308C20.0111 8.92308 22 11.4031 22 14.4615H13.1111ZM13.1111 14.4615C13.1111 17.52 15.1 20 17.5556 20C20.6167 20 21.4444 17.5385 21.4444 17.5385M20.3333 5.23077H14.7778",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceLine);
export default __webpack_public_path__ + "static/media/behance_line.5d81b573005fe3020624535830601ac6.svg";
export { ForwardRef as ReactComponent };